import Disposition from "./disposition";
import DispositionInput from "./disposition_input";

export default class DispositionNode {
    node: Disposition;
    children: DispositionNode[];
    dispositionInputs?: DispositionInput[];

    constructor(disposition: Disposition, children: DispositionNode[], dispositionInputs?: DispositionInput[]) {
        this.node = disposition;
        this.children = children;
        this.dispositionInputs = dispositionInputs;
    }

    private static buildTree(currentNode: DispositionNode, dispositions: Disposition[], dispositionInputs: DispositionInput[]) {
        for (const disposition of dispositions) {
            if (disposition.parent_id === currentNode.node.disposition_id) {
                const dispositionTree = new DispositionNode(disposition, []);
                const finalDisposition = this.buildTree(dispositionTree, dispositions, dispositionInputs);
                currentNode.children.push(finalDisposition);
            }
        }
        if (currentNode.children.length === 0) {
            let dispositionInputArray: DispositionInput[] = [];
            for (const dispositionInput of dispositionInputs) {
                if (dispositionInput.disposition_id === currentNode.node.disposition_id) {
                    dispositionInputArray.push(dispositionInput);
                }
            }
            currentNode.dispositionInputs = dispositionInputArray;
        }
        return currentNode;
    }

    public static initialise(dispositions: Disposition[], dispositionInputs: DispositionInput[]) {
        let rootDispositions: DispositionNode[] = [];
        for (const disposition of dispositions) {
            if (disposition.parent_id === "-1") {
                let rootDisposition = new DispositionNode(disposition, []);
                rootDisposition = this.buildTree(rootDisposition, dispositions, dispositionInputs);
                rootDispositions.push(rootDisposition);
            }
        }
        return rootDispositions;
    }

    private static getDepthHelper(dispositionTree: DispositionNode, currentDepth: number) {
        if (dispositionTree.children.length > 0) {
            let maxDepth = 0;
            for (const child of dispositionTree.children) {
                const depth = this.getDepthHelper(child, currentDepth + 1);
                maxDepth = Math.max(maxDepth, depth);
            }
            return maxDepth;
        } else {
            return currentDepth;
        }
    }

    public static getDepth(dispositionTree: DispositionNode[]) {
        let maxDepth = 0;
        for (const rootNode of dispositionTree) {
            const depth = this.getDepthHelper(rootNode, 1);
            maxDepth = Math.max(maxDepth, depth);
        }
        return maxDepth;
    }
}